import { Card } from '@winnin/winnin_ui.components.card'
import { Icon } from '@winnin/winnin_ui.components.icon'

import BlockComponentsRole75Checker from 'components/BlockComponentsRole75Checker'
import { T } from 'lib/tolgee'

import './index.scss'

export function CreateNewDashboardButton({ onClick, disabled, disabledMessage }) {
  return (
    <BlockComponentsRole75Checker
      tooltipPositionClassname="tooltippedS"
      isClickBlocked={disabled}
      blockMessage={disabledMessage}
    >
      <Card className="CreateNewDashboardButton-container">
        <button className="CreateNewDashboardButton" onClick={onClick}>
          <Icon width={24} height={24} className="create-icon" icon="add" />
          <T keyName="JobsPage-createJobButton-asDashboard">Create new dashboard</T>
        </button>
      </Card>
    </BlockComponentsRole75Checker>
  )
}
